import { createContext } from "react";

type AnalysisContext = {
  readonly readOnly: boolean;
  readonly canAddFamilyMember: boolean;
  readonly versionId: string;
  readonly analysisId: string;
};

export const AnalysisDetailContext = createContext<AnalysisContext>({
  readOnly: false,
  canAddFamilyMember: true,
  versionId: "",
  analysisId: "",
});
